import { render, staticRenderFns } from "./ptTableRowCockfight.vue?vue&type=template&id=67f686d1&lang=pug&"
import script from "./ptTableRowCockfight.vue?vue&type=script&lang=js&"
export * from "./ptTableRowCockfight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports